<!--  -->
<template>
  <div class='roleSelect'>
    <h3 :style="{'margin-bottom':postId==1||postId==2?'0px':'30px','text-align':postId==1||postId==2?'center':'left'}">{{postId==1||postId==2?'上报须知':'欢迎参与，请问您是：'}}</h3>
    <p class='description' v-if='postId==1||postId==2' >本次监测上报主要分为以下执行角色，已默认指定您为“其他数据监测员”，除此之外您还可以根据实际情况选择其它角色：</p>

    <van-checkbox-group v-model="result" @change='handleChangeResult' >
      <van-checkbox name="1">
        <div class="df-item-center">
          <div style='font-size: 16px;'>手卫生观察员</div>
          <span class='importance df-center'>重要</span>
        </div>
        <p class='p-text'>负责分配科室的手卫生依从监测</p>
        <div class="tips">默认该角色提交的时机数才纳入上报统计</div>
      </van-checkbox>
      <van-checkbox name="2" disabled v-if='postId==1||postId==2' >
        <div class="df-item-center">
          <div style='font-size: 16px;'>其他数据监测员</div>
        </div>
        <p class='p-text'>有权限在系统中提交手卫生用品消耗量等数据</p>
        <div class="tips">默认指定“感控科主任/专职感控人员”为该角色</div>
      </van-checkbox>
      <van-checkbox name="3" v-else >
        <div class="df-item-center">
          <div style='font-size: 16px;'>其他医务人员</div>
        </div>
        <p class='p-text'>进行手卫生知识学习，不进行手卫生依从监测</p>
      </van-checkbox>
    </van-checkbox-group>
    <div
      class="btn df-center"
      @click='handleConfirm'
    >确定</div>

  </div>
</template>

<script>
  export default {
    props: ['postId','userPost', 'roleCodeData'],
    data() {
      return {
        result: [],
      }
    },
    watch:{
      roleCodeData(){ // 从上报主页显示
        this.result = this.roleCodeData
      }
    },
    created() {
      if (this.roleCodeData && this.roleCodeData.length > 0) { // 从上报主页显示
        this.result = this.roleCodeData
        return
      }
      if ((this.postId == 1 || this.postId == 2)&&!this.userPost) { //userPost有值表示之前选择过手卫生角色
        this.result.push('2')
      }
      // if(this.userPost){ // 从介绍页面显示
      //   this.result = this.userPost.split(',')
      //   if(this.postId == 1 || this.postId == 2){
      //     let flag = true
      //     let index = ''
      //     let isDel = false
      //     for (let i = 0; i < this.result.length; i++) {
      //       if(this.result[i]=='2'){
      //         flag = false
      //       }
      //       if(this.result[i]=='3'){
      //         index = i
      //         isDel = true
      //       }
      //     };
      //     if(isDel){
      //       this.result.splice(index,1) // 感控科主任或者专职不能存在其他医务人员的角色
      //     }
      //     if(flag){
      //       this.result.push('2')
      //     }
      //   }
      // }else if ((this.postId == 1 || this.postId == 2)&&!this.userPost) { //userPost有值表示之前选择过手卫生角色
      //   this.result.push('2')
      // }
    },
    methods: {
      handleChangeResult() {
        if (this.postId != 1 && this.postId != 2) {
          // 非感控科主任或者专职  只能单选
          if (this.result.length > 1) {
            this.result.splice(0, 1)
          }
        }
      console.log(this.result,'this.result66');

      },
      handleConfirm() {
        this.$emit('conFirmRole', this.result)
      },
    },
  }
</script>
<style lang='scss'>
  .roleSelect {
    .van-checkbox {
      margin-bottom: 20px;
      align-items: flex-start;
      .van-checkbox__icon {
        font-size: 18px;
        margin-top: 3px;
      }
      .van-checkbox__label--disabled {
        color: #333;
      }
    }
  }
</style>
<style lang='scss' scoped>
  .roleSelect {
    width: 310px;
    margin: 0 auto;
    // height: 400px;
    padding: 28px 10px 30px 20px;
    background: #ffffff;
    border-radius: 10px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    .description {
      padding-right: 10px;
      margin: 20px 0px 30px;
    }
    h3 {
      font-size: 18px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 500;
      color: #333333;
    }
    p {
      font-size: 14px;
      color: #666666;
    }
    .importance {
      margin-left: 5px;
      width: 52px;
      height: 22px;
      border: 1px solid #f05757;
      border-radius: 12px;
      font-size: 14px;
      color: #f05757;
    }
    .p-text {
      margin: 8px 0px 3px;
    }
    .tips {
      color: #f05757;
      font-size: 12px;
    }
    .btn {
      width: 215px;
      height: 44px;
      margin: 0 auto;
      background: #1c91ff;
      border-radius: 4px;
      color: #fff;
      font-size: 16px;
    }
  }
</style>